import React from "react";
import ProxyEnvironments from "./ProxyEnvironments";
import ProxySingleEnvironments from "./ProxySingleEnvironments";
import { ResourceAbility } from "libs/security/authorization";

interface ProxyEnvironmentsViewProps {
    proxy: any;  // TODO: Define proper type
    onUpdate?: () => void;
    reload?: () => void;
}

export default function ProxyEnvironmentsView({ proxy, onUpdate, reload }: ProxyEnvironmentsViewProps) {
    return (
        <ResourceAbility 
            can="create" 
            resource={({ Proxy }) => Proxy.org.environment["trimble-prod"]} 
            fallBack={<ProxySingleEnvironments proxy={proxy as any} onUpdate={reload} />}
        >
            <ProxyEnvironments proxy={proxy as any} onUpdate={onUpdate} />
        </ResourceAbility>
    );
}
